import React, { memo } from 'react';
import { CouponTitle, CouponContainer, OfferTitle, OfferContainer } from './style';

const PlaceHolder = () => {
  return (
    <div data-test="offers-placeholder">
      <div>
        <CouponTitle />
        <CouponContainer />
      </div>
      <div>
        <OfferTitle />
        <OfferContainer />
      </div>
    </div>
  );
};

export default memo(PlaceHolder);
